import React from "react";

import { StyledLink } from "./BaseLink.styles";

const BaseLink = ({ to, children }) => {
  return <StyledLink to={to}>{children}</StyledLink>;
};

export default BaseLink;
